import { useQuery } from '@tanstack/react-query';

import { fetchSwingVideos } from '@data';

export const getSwingVideosKey = (uuid: string) => ['swings', uuid, 'videos'] as const;

/**
 * Fetch videos for a swing. The beast listener overrides the cache for this query.
 * We can rely on the cache and there is no need to refetch it.
 */
export const useSwingVideos = (uuid = '') => {
    return useQuery({
        queryKey: getSwingVideosKey(uuid),
        queryFn: () => fetchSwingVideos(uuid),
        enabled: Boolean(uuid),
        retry: true,
        // Once the query is successful we no longer need to query it.
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchInterval: false,
    });
};
